<div class="container">
  <div class="content-card">
    <form [formGroup]="statisticsWorkerAgreementsFormGroup">
      <div class="row">
        <div class="col-12 col-lg-4">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Employer' | translate }}</mat-label>
            <mat-select formControlName="employer">
              @for (employer of listOfEmployers$ | async; track employer) {
                <mat-option
                  #matOption
                  [value]="employer.Id"
                  (onSelectionChange)="setSelectedEmployer(employer)"
                  >{{ employer.Name | translate }}</mat-option
                  >
                }
              </mat-select>
              @if (employer.hasError('required') && employer.touched) {
                <mat-error>
                  {{ 'InvalidFieldSelect' | translate }}
                </mat-error>
              }
              @if (employer.invalid && employer.touched && !employer.hasError('required')) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-lg-4">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'EmployerObject' | translate }}</mat-label>
              <input
                #employerObjectInput
                matInput
                formControlName="employerObject"
                placeholder="{{ 'EmployerObject' | translate }}"
                [matAutocomplete]="autocompleteEmployerObject"
                />
              <mat-icon matSuffix [matTooltip]="'EmployerObjectFilterHint' | translate" matTooltipPosition="above">info</mat-icon>
                <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
                  @if (isEmployerObjectsLoading) {
                    <mat-option disabled>{{ 'Loading' | translate }}</mat-option>
                  }
                  @for (employerObject of listOfEmployerObjects$ | async; track employerObject) {
                    <mat-option [value]="employerObject">
                      {{ employerObject.Name }}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="col-12 col-lg-2">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Statistics.DateFrom' | translate }}</mat-label>
                <input
                  matInput
                  [matDatepicker]="pickdateFrom"
                  formControlName="dateFrom"
                  [matDatepickerFilter]="dateFromFilter"
                  />
                  <mat-datepicker-toggle matSuffix [for]="pickdateFrom"></mat-datepicker-toggle>
                  <mat-datepicker #pickdateFrom></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-12 col-lg-2">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Statistics.DateTo' | translate }}</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickDateTo"
                    formControlName="dateTo"
                    [matDatepickerFilter]="dateToFilter"
                    />
                    <mat-datepicker-toggle matSuffix [for]="pickDateTo"></mat-datepicker-toggle>
                    <mat-datepicker #pickDateTo></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-3">
                  @if (concludedTotal) {
                    <h3>{{ 'Statistics.WorkerAgreementConcluded' | translate }} : {{ concludedTotal }}</h3>
                  }
                </div>
                <div class="col-12 col-lg-3">
                  @if (terminatedTotal) {
                    <h3>{{ 'Statistics.WorkerAgreementTerminated' | translate }} : {{ terminatedTotal }}</h3>
                  }
                </div>
                <div class="col-12 col-lg-6">
                  <button mat-raised-button class="float-right" color="primary" (click)="onSubmit()">
                    {{ 'Generate' | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="row">
            <canvas baseChart [type]="chartType" [data]="data" [options]="options"> </canvas>
          </div>
          <div class="row">
            <div class="col-12 col-lg-12">
              <button mat-raised-button class="float-right" (click)="onBackward()">
                {{ 'Backward' | translate }}
              </button>
            </div>
          </div>
        </div>
